/*
  Sonder scroll-reveal (re-triggering)
  ====================================
  IntersectionObserver that toggles .is-visible on .sonder-reveal
  elements as they enter and leave the viewport. Effect re-fires every
  time you scroll back into a section. No deps.

  Honors prefers-reduced-motion (CSS short-circuits there).
*/
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.sonder-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  function bind() {
    document.querySelectorAll('.sonder-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Re-bind when Shopify section editor swaps content (theme customizer).
  document.addEventListener('shopify:section:load', bind);
})();
